import clsx from 'clsx';
import { ErrorCatcher } from '../../tools/error-catcher';
import { Menu } from '../menu/menu';
import { createSignal, createEffect, onCleanup, onMount } from 'solid-js';
import { useAppContext } from '../../app-context-provider/app-context-provider';
import { useSectionThemeInHeader } from './use-section-theme-in-header';
import { headerColorTheme } from '../../style/color-classes';

export const HeaderContainer = () => {
    const [scrolled, setScrolled] = createSignal(false);
    const { setCurrentHeaderColors, pageTheme } = useAppContext();
    const { headerVariant } = useSectionThemeInHeader();

    const handleScroll = () => {
        setScrolled(window.scrollY > 40);
    };

    onMount(() => {
        window.addEventListener('scroll', handleScroll);
        onCleanup(() => window.removeEventListener('scroll', handleScroll));
    });

    // Uses explicit 'light' or 'dark' variant defined in sectionColorThemeClasses / pageColorThemeClasses
    createEffect(() => {
        const variant = headerVariant() || pageTheme().colors.surface;
        const theme = variant === 'light' ? headerColorTheme.light : headerColorTheme.secondary;
        setCurrentHeaderColors(theme);
    });

    return (
        <ErrorCatcher componentName='Header'>
            <header class={clsx('sticky top-0 w-full z-50', scrolled() ? 'backdrop-blur shadow-tiny' : '')}>
                {/* TODO: fix props */}
                <Menu />
            </header>
        </ErrorCatcher>
    );
};
